<template>
    <div class="error-page">
        <div class="error-page__illustration">
            <MaltImg :src="getBrandIllustration('thinking-malty-red.svg')" width="208" height="237" alt="" />
        </div>
        <div class="error-page__content">
            <div class="error-page__title">
                <slot name="title" />
            </div>

            <div class="error-page__description">
                <slot name="description" />
            </div>

            <div class="error-page__details">
                <slot name="details" />
            </div>

            <div class="error-page__actions">
                <slot name="actions" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {MaltImg} from '#components';
    import {getBrandIllustration} from '@malt/asset-utils';
</script>

<style scoped lang="scss">
    .error-page {
        padding: 35px 0;
        text-align: center;
        color: var(--joy-color-text-default);
        display: flex;
        flex-flow: column wrap;
        align-items: center;

        &__illustration img {
            display: block;
            margin: auto;
            height: auto;
        }

        &__content {
            padding: 0 var(--joy-core-spacing-9);
            max-width: 100%;
            width: 800px;
            margin-top: var(--joy-core-spacing-6);
            display: flex;
            flex-flow: column wrap;
            justify-content: center;
            row-gap: var(--joy-core-spacing-2);
        }

        &__title {
            max-width: 100%;
            display: block;
            font-family: var(--joy-font-family-title);
            font-weight: var(--joy-font-weight-normal);
            font-size: var(--joy-font-size-secondary-600);
            line-height: var(--joy-line-height-small);

            @media (max-width: 767px) {
                font-size: var(--joy-font-size-secondary-400);
            }
        }

        &__description {
            font-family: var(--joy-font-family-base);
            font-weight: var(--joy-font-weight-normal);
            font-size: var(--joy-font-size-primary-800);
            line-height: var(--joy-line-height-large);
            margin: 0;

            @media (max-width: 767px) {
                font-size: var(--joy-font-size-primary-600);
            }
        }

        &__details {
            width: 100%;
        }

        &__actions {
            margin-top: var(--joy-core-spacing-6);
        }
    }

    @media screen and (max-width: 991px) {
        .error-page {
            padding: 50px 0;
            background: none;

            &__illustration img {
                max-width: 175px;
            }
        }
    }
</style>
